exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".carrello-nr[data-v-5e0d4dbd] {\n  text-align: center;\n  bottom: 3px;\n  right: 1px;\n  color: #ffffff;\n  position: absolute;\n  z-index: 10;\n  font-size: 0.65rem;\n  width: 13px;\n}\n.menu--version-4 .carrello-nr[data-v-5e0d4dbd], .menu--version-3 .carrello-nr[data-v-5e0d4dbd] {\n  color: #1a1a1a;\n}\n@media (max-width: 1199px) {\n.carrello-nr[data-v-5e0d4dbd] {\n    bottom: 2px;\n}\n}", ""]);

// exports
